import React, { useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import ScrollToTop from "../components/atoms/scrollRestoration";
import PageWrapper from "../container/pageWrapper/pageWrapper";
import moengage from "@moengage/web-sdk";
import { getAppConfig } from "config/appConfigHelper";
import { MOENGAGE_APP_ID } from "config/envConfig";
const MainSwitch = () => {

  const setMoEngageUniqueId = () => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    try {
      const memberId = userInfo?.metadata?.status?.membership?.mmid;
      if (memberId) {
        moengage.add_unique_user_id(memberId);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (getAppConfig("MOENGAGE_ENABLED") === true) {
      const environment = getAppConfig("ENVIRONMENT");
      const appId = MOENGAGE_APP_ID;
      const cluster = getAppConfig("MOENGAGE_CLUSTER");

      if (!window.ReactNativeWebView) {
        moengage.initialize({
          app_id: appId,
          debug_logs: environment === "PROD" ? 0 : 1,
          cluster: cluster,
          enableSPA: true,
        });

        setTimeout(() => {
          setMoEngageUniqueId();
        }, 2000);
      }
    }
  }, [])

  useEffect(() => {
    window.addEventListener("MOE_AUTOMATED_EVENTS", function (event) {
      if (
        event.detail.name === "MOE_ONSITE_MESSAGE_CLICKED" &&
        event.detail.data &&
        event.detail.data.length
      ) {
      }
      console.log("MoEngage event: ", event);
    });
  }, []);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path="/" render={(props) => <PageWrapper {...props} />} />
        <Redirect from="/" to="/" />
      </Switch>
    </>
  );
};

export default MainSwitch;
